<template>
  <div>
    <v-card class="search-intercom-card border">
      <v-card-title class="search-intercom-card__title">
        <v-icon left class="search-intercom-card__icon">mdi-shield-account</v-icon>
        <span class="search-intercom-card__label">Система контроля и управления доступом!</span>
        <v-btn
          icon
          class="search-intercom-card__close"
          @click="closeModal"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <div class="search-intercom-card__content pa-4 pa-sm-6 pb-8">
        <v-data-table
          class="table"
          v-if="intercoms[0]"
          :headers="headers"
          :items="intercoms"
          :loading="isLoading"
          :options.sync="localOptions"
          :server-items-length="totalIntercoms"
          :footer-props="{
            'items-per-page-options': [5, 15, 50],
            showFirstLastPage: true,
          }"
        >
          <template v-slot:item.address="{ item }">
            <div style="display: flex;">
              {{ item.address }}
              <span v-if="item.entrance">, п. {{ item.entrance }}</span>
              <v-spacer></v-spacer>
              <div
                v-if="item.additional_addresses && item.additional_addresses.length"
                @click.stop="openAdditionalAddressesModal(item.additional_addresses)"
                style="cursor: pointer;"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      color="black"
                      v-bind="attrs"
                      v-on="on"
                      width="18"
                      height="18"
                    >
                      <v-icon>mdi-information-slab-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Дополнительные адреса</span>
                </v-tooltip>
              </div>
            </div>
          </template>
          <template v-slot:item.agent="{ item }">
            <div>
              {{ getAgentName(item.agent_id) }}
            </div>
          </template>
          <template v-slot:item.type="{ item }">
            <div>
              {{ getTranslatedType(item.type) }}
            </div>
          </template>
          <template v-slot:item.physical_status="{ item }">
            <div>
              <v-icon v-if="item.physical_status" x-small :color="physicalStatusColor(item.physical_status)">
                mdi-checkbox-blank-circle
              </v-icon>
                {{ physicalStatus(item.physical_status) }}
            </div>
          </template>
          <template v-slot:item.sip_status="{ item }">
            <div>
              <v-icon x-small :color="getIntercomSipColor(item)">
                mdi-checkbox-blank-circle
              </v-icon>
              {{ getIntercomSipText(item) }}
            </div>
          </template>
          <template v-slot:item.actions="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    text
                    tile
                    small
                    v-bind="attrs"
                    v-on="on"
                    class="btn__icon pa-0"
                    width="18"
                    height="18"
                    @click.prevent="closeModal; changeId(item.id, $event, item.type)"
                  >
                    <v-icon>mdi-information-slab-circle-outline</v-icon>
                  </v-btn>
                </template>
                <span>Информация</span>
              </v-tooltip>
          </template>
        </v-data-table>
      </div>
      <AdditionalAddressModal
        ref="additionalModal"
        :data-addresses="selectedAddresses"
        :is-check-size-small="isDisplaySmall"
        :is-adding-address="false"
      />
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StatusIntercomMixin from '@/mixins/StatusIntercomMixin';
import AdditionalAddressModal from '../../components/barrier/DetailBarrier/components/GeneralInfo/components/AdditionalAddressModal.vue';
import { getBarrierSipStatusColor, getBarrierSipStatusText } from '@/components/barrier/consts';

export default {
  name: 'SearchIntercom',
  components: { AdditionalAddressModal },
  mixins: [StatusIntercomMixin],
  props: {
    intercoms: {
      type: Array,
    },
    totalIntercoms: {
      type: Number,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    options: Object,
  },
  data () {
    return {
      localOptions: this.options,
      selectedAddresses: [],
      isDisplaySmall: true,
      headers: [
        { text: 'id', value: 'id', align: 'center' },
        { text: 'Адрес', value: 'address', align: 'center', sortable: false },
        { text: 'Тип', value: 'type', align: 'center' },
        { text: 'Агент', value: 'agent', align: 'center', sortable: false },
        { text: 'Физический статус', value: 'physical_status', align: 'center', sortable: false },
        { text: 'sip статус', value: 'sip_status', align: 'center', sortable: false },
        { text: '', value: 'actions', align: 'center', sortable: false },
      ],
    };
  },
  created () {
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  watch: {
    localOptions: {
      handler (newOptions) {
        if (JSON.stringify(newOptions) !== JSON.stringify(this.options)) {
          this.$emit('update:options', newOptions);
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      agents: 'Agents/agents',
    }),
  },
  methods: {
    ...mapActions({
    }),
    openAdditionalAddressesModal (addresses) {
      this.selectedAddresses = addresses;
      this.$refs.additionalModal.open();
    },
    checkSize () {
      this.isDisplaySmall = window.innerWidth >= 800;
    },
    getAgentName (agentId) {
      const agent = this.agents.find(agent => agent.id === agentId);
      if (agent) {
        return agent.user.name;
      }
      const intercomWithStatus5 = this.intercoms.find(intercom => intercom.physical_status === 5);
      if (intercomWithStatus5) {
        return 'ООО "КОМПАНИЯ ВОЛНА"';
      }
      return 'Неизвестный агент';
    },
    changeId (id, event, type) {
      const isCtrlPressed = event.ctrlKey || event.metaKey; // event.metaKey для Mac (Cmd key)
      let routeName, path;
      if (type === 'gate') {
        routeName = 'DetailGate';
        path = `/gate/${id}`;
      } else if (type === 'barrier') {
        routeName = 'DetailBarrier';
        path = `/barrier/${id}`;
      } else {
        routeName = 'DetailDoorphone';
        path = `/doorphones/${id}`;
      }

      const routeData = this.$router.resolve({ name: routeName, params: { id: id } });

      if (isCtrlPressed) {
        window.open(routeData.href, '_blank');
      } else {
        window.location.href = path;
      }
    },
    closeModal () {
      this.$emit('close');
    },
    getIntercomSipColor (item) {
      if (item.type === 'barrier') {
        return getBarrierSipStatusColor(item);
      }
      return this.getStatusColor(item.sip_status);
    },
    getIntercomSipText (item) {
      if (item.type === 'barrier') {
        return getBarrierSipStatusText(item);
      }
      return this.getStatusText(item.sip_status);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-intercom-card {
  overflow: hidden;
}

.search-intercom-card__title {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 56px;
  padding: 16px 48px 16px 16px;
  background: linear-gradient(135deg, #6b9b6e 0%, #5a8a5d 50%, #4d7a50 100%);
  color: #fff;
  font-size: 1.25rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.search-intercom-card__icon {
  margin-right: 10px;
  opacity: 0.95;
}

.search-intercom-card__label {
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.search-intercom-card__close {
  position: absolute;
  top: 50%;
  right: 8px;
  margin-top: -20px;
  color: rgba(255, 255, 255, 0.9) !important;

  &:hover {
    color: #fff !important;
    background: rgba(255, 255, 255, 0.15) !important;
  }
}

.search-intercom-card__content {
  background: #fafafa;
}

.border {
  border-radius: 16px;
}

.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}

@media screen and (max-width: 600px) {
  .search-intercom-card__title {
    font-size: 1rem;
    padding-left: 12px;
    line-height: 1.3;
  }

  .search-intercom-card__icon {
    font-size: 1.25rem !important;
  }
}
</style>
